import React from 'react';
import TermCard from './TermCard';
import { CardContext } from 'hoc/withCards';
import ListFilter from 'components/common/list-filter/ListFilter';
import CourseInputAsync from 'components/CourseInputAsync';
import { nativeGet } from 'utils';

const TermList = ({ renderLoading, onChangeForm }) => {
  const onFilterChange = (values) => {
    const params = {
      ...values,
      course: nativeGet(values, 'course.value'),
    };

    onChangeForm(params);
  };

  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          <ListFilter
            type="text"
            searchInputLabel="Buscar"
            onValueChange={onFilterChange}
          >
            <CourseInputAsync field="course" label="Curso" />
          </ListFilter>
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card) => (
                <TermCard key={card.id} id={card.id} term={card} />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

export default TermList;
